// The saved-list picker on an area page.
//
// Almost everything about it is server-rendered and works without this module:
// picking a list is a real link, and clearing one is a link to the bare page.
// That is deliberate - see the note in views/listen/_auswahl.pug on why picking
// is a full navigation rather than a live refetch.
//
// What is left for JavaScript is one thing: carrying the filters currently in
// force across to the create form, so "Neue Liste aus Filtern" does not start
// empty. It cannot be server-rendered, because the rail's filters are applied
// live and the address bar may have moved on since the page was sent.

export function initListeAuswahl() {
  const link = document.getElementById('liste-aus-filtern');
  if (!link) return;

  // Read at click time rather than at load: liveList.js rewrites the address
  // bar as the filters change, so the query string here is the one the reader
  // is actually looking at.
  link.addEventListener('click', () => {
    const aktuell = new window.URLSearchParams(window.location.search);
    const ziel = new window.URL(link.href, window.location.origin);

    aktuell.forEach((value, key) => {
      // `liste` itself is not carried across: the point of the new list is to
      // capture the filters, not to point back at the one they came from.
      // `page` is not a filter either.
      if (key === 'liste' || key === 'page') return;
      ziel.searchParams.set(`aus_${key}`, value);
    });

    link.href = ziel.pathname + ziel.search;
  });
}
